function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Fragment } from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useDirection, usePrefixCls } from '@byte-design/config';
import { RcDialog } from '../../hooks/dialog';
import { Loading } from '../../common/icons';
export function FullLoading(props) {
  var _usePrefixCls;

  var _props$show = props.show,
      show = _props$show === void 0 ? false : _props$show,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$vertical = props.vertical,
      vertical = _props$vertical === void 0 ? 'center' : _props$vertical,
      _props$horizontal = props.horizontal,
      horizontal = _props$horizontal === void 0 ? 'center' : _props$horizontal,
      maskClassName = props.maskClassName,
      icon = props.icon,
      iconStyle = props.iconStyle,
      iconClassName = props.iconClassName,
      label = props.label,
      labelPosition = props.labelPosition,
      labelStyle = props.labelStyle,
      rest = _objectWithoutProperties(props, ["show", "size", "vertical", "horizontal", "maskClassName", "icon", "iconStyle", "iconClassName", "label", "labelPosition", "labelStyle"]);

  var rtl = useDirection() === 'rtl';
  var maskCls = classnames(usePrefixCls('loading-mask', {
    show: show
  }), maskClassName);
  var wrapperCls = usePrefixCls('loading-wrapper', (_usePrefixCls = {}, _defineProperty(_usePrefixCls, "label-position-".concat(labelPosition), true), _defineProperty(_usePrefixCls, "size-".concat(size), true), _defineProperty(_usePrefixCls, "show", show), _defineProperty(_usePrefixCls, "rtl", rtl), _usePrefixCls));
  var iconCls = usePrefixCls('loading-icon');
  var loadingIconCls = classnames(iconCls, iconClassName);
  var labelCls = usePrefixCls('loading-label');
  delete rest.children;
  return React.createElement(Fragment, null, show && React.createElement(RcDialog, Object.assign({
    show: show,
    mask: true,
    vertical: vertical,
    horizontal: horizontal,
    maskClassName: maskCls
  }, rest), React.createElement("div", {
    className: wrapperCls
  }, icon || React.createElement(Loading, {
    className: loadingIconCls,
    style: iconStyle,
    fill: iconStyle === null || iconStyle === void 0 ? void 0 : iconStyle.color
  }), !!label && React.createElement("span", {
    className: labelCls,
    style: labelStyle
  }, label))));
}